import { Box, HStack, Skeleton, Text, VStack } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import type { FC } from 'react'

export const SkeletonText: FC<{ height?: string; width?: string }> = ({
  height = '14px',
  width = '100%',
}) => <Skeleton height={height} width={width} borderRadius="4px" />

export const AnswerSkeleton: FC = () => (
  <VStack spacing="2" align="stretch" w="100%">
    <SkeletonText height="14px" width="100%" />
    <SkeletonText height="14px" width="85%" />
  </VStack>
)

export const LinksSkeleton: FC = () => (
  <Box w="100%">
    <Box mb="2">
      <Text
        fontSize="sm"
        fontWeight="semibold"
        color="greys.300"
        textTransform="uppercase"
        mb="1"
      >
        <Trans>Matching articles</Trans>
      </Text>
    </Box>

    <HStack spacing="2">
      <SkeletonText height="22px" width="180px" />
      <SkeletonText height="22px" width="220px" />
    </HStack>
  </Box>
)
